module.exports = __webpack_public_path__ + "img/app-native.2df5918d.svg";